<template>
  <div v-show="visible" class="modal-wrap">
    <slot></slot>
    <div
      v-if="showBg"
      class="modal-bg"
      :style="{
        'background-color': `rgba(0, 0, 0, ${opacity})`
      }"
      @click="handleClick"
    />
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    showBg: {
      type: Boolean,
      default: true
    },
    opacity: {
      type: Number,
      default: 0.7
    }
  },

  data() {
    return {
      top: 0
    }
  },

  watch: {
    visible() {
      this.$nextTick(() => this.toogleClass())
    }
  },

  beforeDestroy() {
    document.body.classList.remove('modal-open')
    document.body.scrollTop = document.documentElement.scrollTop = this.top
  },

  mounted() {
    this.toogleClass()
  },

  methods: {
    toogleClass() {
      if (this.visible) {
        this.top = document.body.scrollTop || document.documentElement.scrollTop
        document.body.style.top = `-${this.top}px`
        document.body.classList.add('modal-open')
        return
      }
      document.body.classList.remove('modal-open')
      document.body.scrollTop = document.documentElement.scrollTop = this.top
    },

    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="sass">
body.modal-open
  position: fixed
  width: 100%
</style>

<style lang="sass" scoped>
.modal-wrap
  position: fixed
  z-index: 999
  top: 0
  left: 0
  width: 100%
  height: 100%

  .modal-bg
    position: absolute
    left: 0
    top: 0
    z-index: -1
    width: 100%
    height: 100%
    background: rgba(0, 0, 0, .7)
</style>
